<template>
  <div>
      <h3 v-if="msguser && msguser != ''" style="color:green;text-shadow:0px 0px 3px #a5a5a5">
        {{ msguser }}
      </h3>
    <!-- <div class=""> -->

      <!-- CHOOSE TIMES -->
      <section v-if="(booking.booking.status == 'pending' || booking.booking.status == 'viewed') && booking.iam == booking.booking.nextaction" class="booking__availability mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h3 class="booking__availability__instructions" v-if="booking.iam == 'invited'">Please tell us when you’re available to view {{ buildingNumber+" "+getAddress(false,false,false,false,false) }}</h3>
        <h3 class="booking__availability__instructions" v-if="booking.iam == 'inviter'">Suggest an alternative time for {{ (booking.user.fullName ? booking.user.fullName : booking.booking.profileExtra.name) }} to view {{ buildingNumber+" "+getAddress(false,false,false,false,false) }}</h3>
        <option-buttons title="" v-model="day" class="booking__availability-btn" :showMoreButton="true" :items="days.map(function(obj) {return [obj.day, obj.name];})" :numberOfOptionsToShow="2" :cols="3"></option-buttons>
        <option-buttons v-model="hour" class="booking__availability-btn" :showMoreButton="false" :min="minhour" :items="hours.map(function(obj) {return [obj.hour, obj.name];})" :numberOfOptionsToShow="12" :cols="3"></option-buttons>
        <option-buttons v-model="minute" class="booking__availability-btn" :showMoreButton="false" :items="minutes.map(function(obj) {return [obj.minute, obj.name];})" :numberOfOptionsToShow="3" :cols="3"></option-buttons>
        <div class="booking__availability__choosed-time mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="dateSelected !== ''"><span>{{ niceDate(dateSelected,undefined,true) }}</span></div>
        <button class="mdc-button mdc-button--raised btn--spinner btn--spinner__wide-btn booking__send-btn" @click.prevent="processActions('suggest',pickedDates)">
          <span v-if="booking.iam == 'inviter'">
            Save and send to applicant
          </span>
          <span v-else>
            Send
          </span>
        </button>
        <!--
        <button class="mdc-button mdc-button--raised btn--spinner btn--spinner__wide-btn booking__send-btn" @click.prevent="nextDate()" v-if="date < 2">
          Save and suggest other time
        </button>
        -->
        <!-- <button @click.prevent="processActions('suggest',pickedDates[0].datepicked)">{{ niceDate(pickedDates[0].datepicked) }}</button>
        <button @click.prevent="processActions('suggest',pickedDates[1].datepicked)">{{ niceDate(pickedDates[1].datepicked) }}</button>
        <button @click.prevent="processActions('suggest',pickedDates[2].datepicked)">{{ niceDate(pickedDates[2].datepicked) }}</button> -->
      </section>

       <!-- <div class="booking__invitation" v-if="booking && booking.iam == 'invited'"> Mover/Applicant -->

        <!-- <p>
          Thanks {{ (booking.iam == 'inviter') ? booking.agent.name : booking.user.fullName }}, <strong>you have sent your request</strong> to viewthis {{ booking.property.features.slice(0,2).join(', ') }} on {{ booking.property.address.street+', '+booking.property.address.county }} at {{ niceDate(booking.booking.date_suggested) }}.
        </p>
        <p><b>We will confirm your viewing as soon as we can.</b></p>
        <a :href="'https://bestagent.property/p/'+booking.property.propertyId" target="_blank"><img class="booking__invitation__property-img" :src="'https://d3acvr808w2me4.cloudfront.net/'+booking.property.mainImage"/></a>
        <div class="booking__confirmation__buttons">
          <button class="btn btn--bordered booking__cancel-btn" @click.prevent="processActions('cancel')">Cancel Viewing request</button>
        </div>
      </div> -->

      <!-- VIEWING CONFIRMATION -->
      <section class="booking__confirmation" v-else-if="booking.booking.status == 'suggested' && booking.iam == booking.booking.nextaction">
				<center>
        <div v-if="booking.booking.date_remember && booking.booking.date_remember !== true && (!msguser || msguser == '')">
          You will be reminded, {{ niceDateAt(booking.booking.date_remember) }}
        </div>
				<!--
        <div class="margin-top-60 text-center" v-else>
          <p class="mdc-theme-primary-dark loading-text">Loading<span>.</span><span>.</span><span>.</span></p>
        </div>
				-->
        <div v-else>
          <div class="booking__confirmation__icon"><i class="ico ico-checkmark"></i></div>
          <p>{{ niceDate(booking.booking.date_suggested) }}</p>
          <p>{{ booking.property.address.street }}</p>
					<button class="mdc-button mdc-button--raised btn--spinner" @click.prevent="processActions('confirm')">Confirm at {{ niceDate(booking.booking.date_suggested) }}</button>
					<button class="mdc-button mdc-button--raised btn--spinner" @click.prevent="processActions('newsuggest')">Or suggest new date</button>
          <!-- <button @click.prevent="processActions('confirm')">Confirm at {{ niceDate(booking.booking.date_suggested) }}</button>
          <span v-if="booking.booking.date_othersuggested && booking.booking.date_othersuggested.length > 0">
            <button v-if="booking.booking.date_othersuggested[0]" @click.prevent="processActions('confirm',booking.booking.date_othersuggested[0])">Confirm at {{ niceDate(booking.booking.date_othersuggested[0]) }}</button>
            <button v-if="booking.booking.date_othersuggested[1]" @click.prevent="processActions('confirm',booking.booking.date_othersuggested[1])">Confirm at {{ niceDate(booking.booking.date_othersuggested[1]) }}</button>
          </span> -->
          <!-- <button @click.prevent="processActions('newsuggest')">Or suggest new date</button> -->
          <!-- <div class="text-center booking__confirmation__add-to-calendar">Add to calendar</div>
          <div class="mdc-layout-grid mdc-layout-grid__inner">
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-2-phone booking__calendar">
              <div class="btn btn--bordered booking__calendar-btn" @click.prevent="getCal('ical')"><img class="booking__calendar-buttons__icon" src="/static/img/ical-icon.jpg"><br>iCal</div>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-2-phone booking__calendar">
              <div class="btn btn--bordered booking__calendar-btn" @click.prevent="getCal('ical')"><img class="booking__calendar-buttons__icon" src="/static/img/outlook-icon.png">Outlook</div>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-2-phone booking__calendar">
              <div class="btn btn--bordered booking__calendar-btn" @click.prevent="getCal('google')"><img class="booking__calendar-buttons__icon" src="/static/img/GoogleCalendar-icon.png">Google Calendar</div>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2 mdc-layout-grid__cell--span-2-phone booking__calendar">
              <div class="btn btn--bordered booking__calendar-btn" @click.prevent="getCal('yahoo')"><img class="booking__calendar-buttons__icon" src="/static/img/yahoo-icon.png"></div>
            </div>
          </div>-->
					<p><br>
	        Or ask me again<br>
	        <button class="mdc-button" @click.prevent="processActions('later',30)">In 30min</button> <button  class="mdc-button" @click.prevent="processActions('later',60)">In 1hour</button> <button  class="mdc-button" @click.prevent="processActions('later',(60*24))">Tomorrow</button>
					</p>
				</div>
			</center>
      </section>

      <!-- Mover/Applicant -->
      <section class="booking__request-sent" v-else-if="booking.iam != booking.booking.nextaction">
        <div v-if="booking.iam == 'inviter'">
          <p>
            You have successfully invited {{ (booking.user.fullName ? booking.user.fullName : booking.booking.profileExtra.name) }} to view {{ buildingNumber+" "+getAddress(false,false,false,false,false) }} {{ niceDateAt(booking.booking.date_suggested) }}.
          </p>
          <p>
            <b>Viewing Status: awaiting confirmation from applicant.</b>
          </p>
          <p>
            <center><small>We will notify you as soon as the applicant accepts.</small></center>
          </p>
          <div class="booking__request-sent__img">
            <img class="booking__invitation__property-img" v-if="booking.property.mainImage !== null" :src="fixImg(booking.property.mainImage)" alt="property image">
          </div>

          <a class="btn btn--bordered booking__cancel-btn" href="/" style="font-size:19px">Back to BestAgent</a>
        </div>
        <div v-else-if="booking.iam == 'invited'">
          <p>
            Thanks {{ (booking.iam == 'inviter') ? booking.agent.name : (booking.user.fullName ? booking.user.fullName : booking.booking.profileExtra.name) }}, <strong>  you have sent your request to view </strong> this {{ booking.property.bedrooms+' bed '+booking.property.type }} on {{ buildingNumber+" "+getAddress(false,false,false,false,false) }} {{ niceDateAt(booking.booking.date_suggested) }}.
          </p>
          <p>
            <p><b>We will confirm your viewing as soon as we can.</b></p>
          </p>
          <div class="booking__request-sent__img">
            <a :href="this.linkprop" target="_blank">
              <img class="booking__invitation__property-img" v-if="booking.property.mainImage !== null" :src="fixImg(booking.property.mainImage)" alt="property image">
              <span v-if="booking.property.mainImage === '' || booking.property.mainImage === null">View property</span>
            </a>
            <!-- <a :href="booking.property.brochure" target="_blank" v-else>View property</a> -->
            <!-- <a :href="booking.property.brochure" target="_blank" v-else>View brochure</a> -->
          </div>
          <!-- {{ booking.iam == 'inviter' ? 'mover' : 'agent' }} -->
          <a class="btn btn--bordered booking__cancel-btn" :href="this.linkprop" style="font-size:19px" target="_blank">View property details</a>
          <div class="btn btn--bordered booking__cancel-btn" @click.prevent="processActions('cancel')"><span>Cancel Viewing Request</span></div>
        </div>
      </section>
  </div>
</template>
<script>
import api from '@/libs/api.js';
import OptionButtons from '../../components/OptionButtons.vue';
function dtstamp(date) {
  let redate = date ? new Date(date) : new Date();
  let strout = redate.getFullYear();
  strout += ("0" + (redate.getMonth()+1)).slice(-2);
  strout += ("0" + redate.getDate()).slice(-2);
  strout += "T";
  strout += ("0" + redate.getHours()).slice(-2);
  strout += ("0" + redate.getMinutes()).slice(-2);
  strout += "00Z";
  return strout;
}

export default {
	props: {
		booking: Object
	},
	data: function() {
		return {
      msguser: undefined,
      calendars: undefined,
      directions: undefined,
      pickedDates: [
        {date: 0, datepicked: undefined},
        {date: 1, datepicked: undefined},
        {date: 2, datepicked: undefined},
      ],
      linkprop: '',
      date: 0,
      day: 0,
      minhour: 0,
      hour: 0,
      minute: 0,
      days: [
        {day: 0, name: 'Today'},
        {day: 1, name: 'Tomorrow'},
        {day: 2, name: 'Saturday 19'},
        {day: 3, name: 'Monday 21'},
        {day: 4, name: 'Tuesday 22'},
        {day: 5, name: 'Wednesday 23'}
      ],
      hours: [
        {hour: 0, name: '8AM'},
        {hour: 1, name: '9AM'},
        {hour: 2, name: '10AM'},
        {hour: 3, name: '11AM'},
        {hour: 4, name: '12PM'},
        {hour: 5, name: '1PM'},
        {hour: 6, name: '2PM'},
        {hour: 7, name: '3PM'},
        {hour: 8, name: '4PM'},
        {hour: 9, name: '5PM'},
        {hour: 10, name: '6PM'},
        {hour: 11, name: '7PM'}
      ],
      minutes: [
        {minute: 0, name: ':15'},
        {minute: 1, name: ':30'},
        {minute: 2, name: ':45'}
      ],
		}
	},
	created: async function() {
    let that = this;
    let booking = this.booking;
    this.linkprop = 'https://bestagent.property/p/'+this.booking.property.propertyId;
    if (this.booking.booking.profileExtra.applicantId) {
      this.linkprop += '?ref='+this.booking.booking.profileExtra.applicantId;
    }




    const direction = `https://www.google.com/maps/dir/Current+Location/${booking.property.address.latitude},${booking.property.address.longitude}`;
    const cal_title = encodeURIComponent('Viewing '+booking.property.address.buildingNumber+' '+booking.property.address.street);
    const fulladdr = `${booking.property.address.buildingNumber} ${booking.property.address.street}, ${booking.property.address.town}, ${booking.property.address.county}, ${booking.property.address.postcode}`;
    const cal_addr = encodeURIComponent(fulladdr);
    let cal_specs = `${fulladdr}\n`;
    if (booking.iam == 'inviter') {
      if (booking.booking.profileExtra.name) {
        cal_specs += `${booking.booking.profileExtra.name}\n`;
        if (booking.booking.profileExtra.phone) {
          cal_specs += `${booking.booking.profileExtra.phone}\n`;
        }
      } else if (booking.user) {
        cal_specs += `${booking.user.fullName}\n`;
        if (booking.user.phone) {
          cal_specs += `${booking.user.phone}\n`;
        }
      }
    } else {
      cal_specs += `${booking.agent.name}\n`;
      cal_specs += `${booking.agent.phone ? booking.agent.phone : ''}\n`;
    }

    cal_specs += "\nDirections:\n"+direction;
    cal_specs = encodeURIComponent(cal_specs);

    this.calendars = {
      "ical": `${this.config.services.booking}/webcal/${this.$parent.trackId}/${this.$parent.userId}`,
      "outlook": `${this.config.services.booking}/webcal/${this.$parent.trackId}/${this.$parent.userId}`,
      "google": `http://www.google.com/calendar/event?location=${cal_addr}&action=TEMPLATE&sprop=name%3A${encodeURIComponent(booking.company.companyName)}&sprop=website%3A${encodeURIComponent(window.location.href)}&details=${cal_specs}&text=${cal_title}&dates=${dtstamp(booking.booking.date_suggested)}%2F${dtstamp(parseInt(booking.booking.date_suggested) + 900000)}`,
      "yahoo": `http://calendar.yahoo.com/?in_loc=${cal_addr}&v=60&VIEW=d&TYPE=20&TITLE=${cal_title}&ST=${dtstamp(booking.booking.date_suggested)}&DUR=0015&URL=${encodeURIComponent(window.location.href)}&DESC=${cal_specs}`
    };
    this.directions = direction;


    await this.processActions();
    // this.pickedDates[0].datepicked = new Date(this.booking.booking.date_suggested + ((1*(60*60))*1000)).getTime(); // +1h
    // this.pickedDates[1].datepicked = new Date(this.booking.booking.date_suggested + ((2*(60*60))*1000)).getTime(); // +2h
    // this.pickedDates[2].datepicked = new Date(this.booking.booking.date_suggested + ((3*(60*60))*1000)).getTime(); // +3h
    //console.log((new Date(this.booking.booking.date_suggested).toString()));
    await Promise.all(this.days.map(d => {
      let thisDate = new Date();
      if (d.day == 0) {
        that.days[d.day].name = 'Today';
        thisDate.setDate(thisDate.getDate());
        that.days[d.day].dateobj = thisDate;
      }
      else if (d.day == 1) {
        that.days[d.day].name = 'Tomorrow';
        thisDate.setDate(thisDate.getDate() + 1);
        that.days[d.day].dateobj = thisDate;
      } else {
        thisDate.setDate(thisDate.getDate() + (d.day));
        that.days[d.day].name = this.niceDate(thisDate.getTime(),true);
        that.days[d.day].dateobj = thisDate;
      }
    }));
    this.days = that.days;

    this.disableHours();

    if (this.booking.booking.date_othersuggested && this.booking.booking.date_othersuggested.length) { // Use known suggestions
      this.pickedDates[0].datepicked = this.booking.booking.date_suggested;
      this.pickedDates[1].datepicked = this.booking.booking.date_othersuggested[0];
      this.pickedDates[2].datepicked = this.booking.booking.date_othersuggested[1];
    } else { // Predict
      let addedNextDay = 0;
      let i=0;
      await Promise.all(this.pickedDates.map(dt => {
        this.pickedDates[i].datepicked = new Date(this.booking.booking.date_suggested + ((i*(60*60))*1000)); // +1h each date
        if (this.pickedDates[i].datepicked.getHours() > 19) {
          addedNextDay++;
          this.pickedDates[i].datepicked.setDate(new Date(this.pickedDates[0].datepicked).getDate()+1);
          this.pickedDates[i].datepicked.setHours(9+(addedNextDay-1));
        }
        this.pickedDates[i].datepicked = this.pickedDates[i].datepicked.getTime();
        i++;
      }));
    }

    this.selectDatePicker(this.date);
  },
  components: {
    'option-buttons': OptionButtons
  },
  watch: {
    date: function(val) {
      if (val >= 0 && val <= 2) {
        this.dateSet(val,undefined,undefined,undefined);
        this.selectDatePicker(val);
      }
    },
    day: function(val) {
      this.disableHours();
      if (val >= 0) {
        this.dateSet(this.date,val,undefined,undefined);
      }
    },
    hour: function(val) {
      if (val >= 0) {
        this.dateSet(this.date,this.day,val);
      }
    },
    minute: function(val) {
      this.dateSet(this.date,this.day,this.hour,val);
    }
  },
  computed: {
    dateSelected: function() {
      var pickedDate = '';
      if (this.date === 0) {
        pickedDate = this.pickedDates[0].datepicked;
      } else if (this.date === 1) {
        pickedDate = this.pickedDates[1].datepicked;
      } else if (this.date === 2) {
        pickedDate = this.pickedDates[2].datepicked;
      }
      //console.log("pickedDate",pickedDate);
      return pickedDate;
    },
    buildingNumber: function() {
      if (this.$parent.booking.iam == 'invited' && this.$parent.phase != 'confirmation') {
        return ""
      } else {
        return this.$parent.booking.property.address.buildingNumber
      }
    }
  },
	methods: {
    fixImg(img) {
      if (img.indexOf('https://') !== -1) {
        return img;
      } else {
        return `https://d3acvr808w2me4.cloudfront.net/${img}`;
      }
    },
    disableHours: function(){
      if (this.day != 0) {
        this.minhour = 0;
        return true;
      }

      const foundHour = this.hours.filter(h => {
        let dt = (new Date().getHours());
        var ampm = dt >= 12 ? 'PM' : 'AM';
        dt = dt % 12;
        dt = dt ? dt : 12;
        return h.name == dt+ampm
      });

      if (foundHour.length) {
        this.minhour = foundHour[0].hour;
        if (this.minhour != 0) {
          this.minhour += 3;
        }
      }
    },
    selectDatePicker: function(date) {
      // Selected date reflected on buttons using v-model
      //console.log('this.pickedDates[date].datepicked',new Date(this.pickedDates[date].datepicked).toString());
      if (this.pickedDates[date].datepicked && this.pickedDates[date].datepicked !== undefined && this.pickedDates[date].datepicked != '') {
        const diffl = Math.abs((new Date(this.pickedDates[date].datepicked).getTime()) - (new Date().getTime()));
        const foundD = this.days.filter(d => {
          return d.dateobj.getDate() == (new Date(this.pickedDates[date].datepicked).getDate());
        });
        if (foundD && foundD.length) {
          this.day = foundD[0].day;
        } else {
          this.day = Math.floor(diffl / (86400 * 1000));
        }
      }

      const thistmphour = (new Date(this.pickedDates[date].datepicked).getHours());
      const tmpselhour = this.hours.filter(h => {
        return ((h.name == (thistmphour > 12 ? (thistmphour-12)+'PM' : thistmphour+'AM')) || (thistmphour == 12 && h.name == (thistmphour+'PM')));
      });
      this.hour = tmpselhour[0].hour;
      let tmpmins = (new Date(this.pickedDates[date].datepicked).getMinutes());
      if (tmpmins == 0) { // pick no minutes?
        this.minute = -1;
      } else if (tmpmins <= 20) {
        let nwdt = new Date(this.pickedDates[date].datepicked);
        nwdt.setMinutes(15);
        this.pickedDates[date].datepicked = nwdt.getTime();
        this.minute = 0;
      } else if (tmpmins < 40) {
        let nwdt = new Date(this.pickedDates[date].datepicked);
        nwdt.setMinutes(30);
        this.pickedDates[date].datepicked = nwdt.getTime();
        this.minute = 1;
      } else if (tmpmins >= 40) {
        let nwdt = new Date(this.pickedDates[date].datepicked);
        nwdt.setMinutes(45);
        this.pickedDates[date].datepicked = nwdt.getTime();
        this.minute = 2;
      }
    },
    dateSet: function(date, day, hour, minute) {
      if (!date && date != 0) {
        return false;
      }
      this.date = date;
      if (!day) {
        day = this.day;
      }
      if (!hour) {
        hour = this.hour;
      }

      if (!minute) {
        minute = this.minute;
      }
			//console.log('minute',minute);
      //console.log(`date${date} day${day} hour${hour} minute${minute}`);
      //console.log('this.days[day].dateobj',this.days[day].dateobj);
      if (day || day == 0) {

        let newDT = this.days[day].dateobj.getDate() == (this.pickedDates[date].datepicked && (new Date(this.pickedDates[date].datepicked).getDate())) ? (new Date(this.pickedDates[date].datepicked)) : this.days[day].dateobj;
        if (hour || hour == 0) {
          let rhour = parseInt(this.hours[hour].name.replace('PM','').replace('AM',''));

          if (this.hours[hour].name.indexOf('PM') !== -1 && this.hours[hour].name != '12PM') {
            rhour+=12;
          }
          newDT.setHours(rhour);
        }
        if (minute !== undefined && this.minutes[minute]) {
          newDT.setMinutes(parseInt(this.minutes[minute].name.replace(':','')));
        } else {
          //newDT.setMinutes(((parseInt(new Date(this.pickedDates[date].datepicked).getMinutes()) >= 0) ? new Date(this.pickedDates[date].datepicked).getMinutes() : 0));
					newDT.setMinutes(0);
        }
        this.pickedDates[date].datepicked = newDT;
      }
    },
    async processActions(forceaction,forceparams) { // App actions for GET and Live inputs
      var that = this;
      const validatePath = window.location.pathname.split('/');
      const params = forceparams ? forceparams : this.$parent.params;
      if ((!this.$parent.action && !forceaction)) {
        return false;
      }
      const cleanPath = `/${validatePath[1]}/${validatePath[2]}/${validatePath[3]}`;
      const hasGET = validatePath[4] ? true : false;
      const action = forceaction ? forceaction : this.$parent.action;

			// Pre-render action
			const oldbooking = this.booking;
      if (action == 'cancel') {
        this.$parent.phase = 'closed';
        this.booking.booking.phase = 'closed';
        this.booking.booking.status = 'cancelled';
        this.$parent.booking.booking.phase = 'closed';
        this.$parent.booking.booking.status = 'cancelled';
        //if (confirm('Are you sure you want to cancel this viewing?') === false) {
        //  return true;
        //}
      } else if (action == 'confirm') {
				if (this.$parent.booking.iam == 'invited') {
					this.$parent.booking.booking.status = 'accepted';
				} else {
					this.$parent.booking.booking.status = 'pending';
				}
				this.$parent.booking.booking.phase = 'confirmation';
				this.$parent.phase = 'confirmation';
				if (params)this.$parent.booking.booking.date_suggested = params;
				this.$parent.booking.booking.nextaction = this.$parent.booking.iam == 'inviter' ? 'invited' : 'inviter';
			} else if (action == 'newsuggest') {
				this.$parent.booking.booking.status = 'pending';
				this.$parent.booking.booking.phase = 'schedule';
				this.booking.booking.status = 'pending';
				this.booking.booking.phase = 'schedule';
			} else if (action == 'suggest') {
				this.$parent.booking.booking.date_suggested = params[0].datepicked;
				this.$parent.booking.booking.phase = 'schedule';
				this.$parent.booking.booking.status = 'suggested';
				this.$parent.booking.booking.nextaction = this.$parent.booking.iam == 'inviter' ? 'invited' : 'inviter';
				this.booking.booking.phase = 'schedule';
				this.booking.booking.status = 'suggested';
				this.booking.booking.nextaction = this.$parent.booking.iam == 'inviter' ? 'invited' : 'inviter';
			}


      let bookingUpdate;
      try {
        switch(action) {
          case "suggest":
            //console.log('picking date:' +  params);
            bookingUpdate = await api({endpoint: this.config.services.booking, path: '/bookingSchedule/'+this.$parent.trackId+'/'+this.$parent.userId, method: 'POST', body: {
             action: "suggest",
             newtime: params
            }});
            break;
          case "confirm":
           bookingUpdate = await api({endpoint: this.config.services.booking, path: '/bookingSchedule/'+this.$parent.trackId+'/'+this.$parent.userId, method: 'POST', body: {
              action: "confirm",
              realtime: params
           }});
           break;
          case "newsuggest":
           bookingUpdate = await api({endpoint: this.config.services.booking, path: '/bookingSchedule/'+this.$parent.trackId+'/'+this.$parent.userId, method: 'POST', body: {
               action: "newsuggest"
            }});
           break;
          case "later":
           bookingUpdate = await api({endpoint: this.config.services.booking, path: '/bookingSchedule/'+this.$parent.trackId+'/'+this.$parent.userId, method: 'POST', body: {
             action: "later",
             interval: params
           }});
           break;
          case "cancel":
            bookingUpdate = await api({endpoint: this.config.services.booking, path: '/cancel/'+this.$parent.trackId+'/'+this.$parent.userId, method: 'GET'});
            break;
          default:

           break;
        }
      } catch(e) {
        console.log(e.message);
        if (hasGET)window.location.pathname = cleanPath;
      }
      if (!bookingUpdate) { // Error
				this.booking = oldbooking;
				this.$parent.booking = oldbooking;
				this.$parent.phase = oldbooking.booking.phase;
        return false;
      } else {
        if (action == 'confirm') {
          //if (hasGET) {
          //  window.location.pathname = cleanPath;
          //}
        } else if (action == 'suggest') {
          //if (hasGET) {
          //  console.log('window.location.pathname.f',window.location.pathname.replace('suggest', 'newsuggest'));
          //  window.location.pathname = window.location.pathname.replace('suggest', 'newsuggest');
          //}
        } else if (action == 'later') {
          this.$parent.booking.booking.date_remember = (new Date().getTime() + (parseInt(params) * (60*1000)));
          this.booking.booking.date_remember = (new Date().getTime() + (parseInt(params) * (60*1000)));
          this.msgUser('You will be reminded, '+niceDateAt(this.$parent.booking.booking.date_remember));
          //if (hasGET)window.location.pathname = cleanPath;
        } else if (action == 'cancel') {
          //this.msgUser('Booking view cancelled.');
          //setTimeout(function(){
          //  window.location.pathname = cleanPath;
          //},2000);
        }
      }
    },
    msgUser(msg) {
      this.msguser = msg;
    },
    niceValue(value) {
      let kk = '';
      if (value.toString().length > 3) {
        kk = 'k';
      } else if (value.toString().length > 6) {
        kk = 'kk';
      }
      return value.toString().substr(0,3)+kk;
    },
    niceDateAt(datetime,nohours,withminutes) {
      const dt = this.niceDate(datetime,nohours,withminutes);
      if (dt.indexOf('Today') !== -1 || dt.indexOf('Tomorrow') !== -1) {
        return dt;
      } else {
        return 'on '+dt;
      }
    },
    niceDate(datetime,nohours,withminutes) {
      var notnow = new Date(datetime);
      var now = new Date();
      var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','October','Nov','Dec'];

      var day = days[ notnow.getDay() ];
      var month = months[ notnow.getMonth() ];

      var date = notnow.getDate();
      var hours = notnow.getHours();
      var ampm = hours >= 12 ? ' pm' : ' am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      var dateString = '';
      if (notnow.getDay() == now.getDay() && notnow.getMonth() == now.getMonth() && notnow.getFullYear() == now.getFullYear()) {
        dateString += "Today";
      }
      else if (notnow.getDay() == (now.getDay()+1) && notnow.getMonth() == now.getMonth() && notnow.getFullYear() == now.getFullYear()) {
        dateString += "Tomorrow";
      } else {
        dateString += day+" " +date;
        dateString += (now.getMonth() == notnow.getMonth()) ? '' : ', '+month;
      }
      if (!nohours) {
        let reDatehour = '';
        reDatehour += " "+hours;
        if (parseInt(notnow.getMinutes()) != 0)
          reDatehour += ":"+notnow.getMinutes();
        reDatehour += " "+ampm;
        dateString = dateString+" at "+reDatehour;
      }

      return dateString;
    },
    getCal(type) {
      if (this.calendars[type])
       window.location.href = this.calendars[type];
    },
    nextDate(){

      this.date += 1;
    },
		getAddress(full,buildingnr,county,town,postcode) {
			let ret = '';
      if (full || buildingnr) {
        ret += this.booking.property.address.buildingNumber;
      }
      if (ret != '')ret += ' ';
			ret += this.booking.property.address.street;
			if (full || county) {
				if (ret != '')ret += ', ';
				ret += this.booking.property.address.county;
			}
			if (full || town) {
				if (ret != '')ret += ', ';
				ret += this.booking.property.address.town;
			}
			if (full || postcode) {
				if (ret != '')ret += ', ';
				ret += this.booking.property.address.postcode;
			}
      return ret;
		}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/booking/schedule.vue